
export const siteSettings = {
    name: "هيام",
    shortName: "هيام",
    description: "هيام | Hyam Coffee",
    themeColor: {
        light: "#ffffff",
        dark: "#374151"
    },
    backgroundColor: "#ffffff",
    display: "standalone",
    scope: "/",
    startUrl: "/",
    categories: ["food", "restaurant"],
    orientation: "portrait",
    language: "ar",
    direction: "rtl"
};

// إعدادات التثبيت
export const installSettings = {
    enabled: true, // تفعيل أو تعطيل نافذة التثبيت
    title: "تثبيت قهوة هيام",
    description: "قم بتثبيت قهوة هيام للوصول السريع والاستخدام بدون إنترنت",
    safari: {
        title: "اتبع الخطوات التالية : ",
        steps: [
            "اضغط على زر المشاركة",
            "اختر إضافة إلى الصفحة الرئيسية",
            <>اضغط على <span className="font-bold text-[#007AFF]">إضافة</span></>
        ]
    },
    chrome: {
        title: "تثبيت قهوة هيام على جهازك",
        description: "قم بتثبيت قهوة هيام للوصول السريع والاستخدام بدون إنترنت"
    },
    buttons: {
        install: "تثبيت",
        later: "لاحقاً",
        understood: "فهمت"
    }
};
